import mobileAdjustment from "../GeneralMobileAdjustments";
import themeService     from 'ThemeService';
import mobileConstants from "../../../mobile/commons/MobileFormsConstants";

class MobileFileAttachmentControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        element.css({"height":"auto", "text-align":"left", "background-color": ""});

        let input = element[0].lastElementChild;
        let inputFontSize = control.model.get("fontSize");
        inputFontSize = themeService.isThemeProperty(inputFontSize) ? themeService.getValueFromTheme(themeService.resolve(inputFontSize), 'fontSize') : inputFontSize;
        
        let button = element[0].firstElementChild;
        let buttonFontSize = control.model.get("buttonFontSize");
        buttonFontSize = themeService.isThemeProperty(buttonFontSize) ? themeService.getValueFromTheme(themeService.resolve(buttonFontSize), 'fontSize') : buttonFontSize;
        
        let height = parseInt(inputFontSize) >= parseInt(buttonFontSize) ? inputFontSize : buttonFontSize;
        height = height * mobileConstants.LINE_HEIGHT_FACTOR + 2;

        input.style.lineHeight = `${height + 10}px`;
        button.style.height = "auto";
        button.style.padding = "3px";
        button.style.minHeight = '';
        button.style.lineHeight = `${height}px`;
        button.style.whiteSpace = 'normal';
        button.style.maxWidth = "50%";
    }
}

const mobileFileAttachmentControlView = new MobileFileAttachmentControlView();
export default mobileFileAttachmentControlView;